import { useState } from "react";
import { Modal } from 'react-bootstrap';
import DeviceService from "../../Services/DeviceService";
import { ReactComponent as Close } from '../../Assets/img/Close.svg';
import { ReactComponent as UploadDeviceIcon } from '../../Assets/img/Upload-icon.svg';
import { ReactComponent as DownloadIcon } from '../../Assets/img/Download-primary-icon.svg';
import jsonParser from "papaparse";
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import MessagePopup from "../PopupComponent/MessagePopup";
import $ from 'jquery';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';

/**
 * Renders upload device pop up to upload device
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function UploadDevice(props) {

    //#region States 

    const [jsonData, setJsonData] = useState([]);
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);
    const [fileType, setFileType] = useState("");
    const [fileName, setFileName] = useState("");

    //#endregion

    //#region onChangeHandler

    /**
    * Extracts data from the CSV file and stores as JSON object
    * @param {Event} event  User action (on changing value)
    */
    const onChangeHandler = (event) => {
        if (event.target.files.length != 0) {
            setFileName(event.target.files[0].name);
            setFileType(event.target.files[0].type);
            jsonParser.parse(event.target.files[0], {
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    setJsonData(results.data);
                }
            });
            $("#uploadFile")[0].value = '';
            setError("");
            setMessagePopup(false);
        }
        else {
            setFileName("");
            setFileType("");
            setJsonData([]);
        }
    };

    //#endregion

    function messagePopupCloseHandler() {
        setError("");
        setMessagePopup(false);
    }

    /**
    *  download the csv file for registered and failed devices
    *  @param {Event} data details of registered and failed devices
    *  @param {string} fileName name of the file to download
    */
    const download = function (data, fileName = 'FailedDevices.csv') {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', fileName);
        a.click()
    }

    /**
    * Creates CSV file from given data
    *  @param {Event} data details of registered and failed devices
    */
    const csvmaker = function (data) {
        var csvRows = [];
        const headers = Object.keys(data[0]);
        csvRows.push(headers.join(','));
        data.forEach((d) => {
            const values = Object.values(d).join(',');
            csvRows.push(values)
        })
        return csvRows.join('\n')
    }

    /**
    * Downloads a sample CSV with the header row and one example data row,
    * so the user can see the expected columns and date format before filling it in
    */
    const downloadSampleCsv = () => {
        const sample = "Name,SerialNum,Make,Model\nSampleDevice,SAMPLE12345,SampleMake,SampleModel";
        download(sample, "SampleDevices.csv");
    };


    //#region Upload device

    /**
    * Calls device service to upload the devices 
    * @param {Event} event  User action (on submitting form)
    */
    async function uploadDevice(event) {

        event.preventDefault();

        if (jsonData.length == 0) {
            setError("Select a file");
            setMessagePopup(true);
            return;
        }

        if (fileType != "text/csv") {
            setError("Invalid file type.");
            setMessagePopup(true);
            return;
        }

        var devices = [];
        jsonData.forEach(deviceData => {
            var key, keys = Object.keys(deviceData);
            var n = keys.length;
            var device = {}
            while (n--) {
                key = keys[n];
                device[key.toLowerCase()] = deviceData[key];
            }
            var request = {
                Name: device.name ?? null,
                SerialNum: device.serialnum ?? null,
                IsActive: (device.isactive === undefined || device.isactive === "") ? true : device.isactive,
                IsItForRegistration: (device.isitforregistration === undefined || device.isitforregistration === "") ? false : device.isitforregistration,
                DeviceModel: {
                    Id: null,
                    Make: device.make ?? null,
                    Model: device.model ?? null
                }
            }
            devices.push(request);
        });

        var request = {
            DeviceDetails: devices
        }

        DeviceService.UploadDevices(request)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    var created = response.response.deviceDetailCreated;
                    var errors = response.response.errors;
                    var idsFailed = response.response.idsFailed;
                    if (created == null || created.length == 0) {
                        errors.forEach((error, ind, arr) => {
                            jsonData[ind].error = error.message;
                        });
                        const csvdata = csvmaker(jsonData);
                        download(csvdata);
                        setError(errors.length + " / " + (errors.length + created.length) + " Devices Not Registered.");
                        setMessagePopup(true);
                    }
                    else if (errors == null || errors.length == 0) {
                        props.onClose();
                        props.onShowMessage(created.length + " / " + (errors.length + created.length) + " Devices created sucessfully.");

                    }
                    else {
                        var data = [];
                        errors.forEach((error, ind, arr) => {
                            jsonData[idsFailed[ind]].error = error.message;
                            data[ind] = jsonData[idsFailed[ind]];
                        });
                        const csvdata = csvmaker(data);
                        download(csvdata);
                        props.onClose();
                        props.onShowMessage(created.length + " / " + (errors.length + created.length) + " Devices created sucessfully.");
                    }
                }
            })
            .catch((err) => {
                setMessagePopup(true);
                if (err.code == "ERR_BAD_REQUEST") {
                    setError("Invalid Data: " + err.response.data.errors[0].message);
                } else {
                    setError("Unable to register the devices.");
                }

            });
    }
    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>
            <Modal.Header className="AddDeviceHeader" style={{ border: "none" }} closeButton>
                <Modal.Title className="Header"><strong>Upload Device</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={uploadDevice}>
                    <br />
                    <div style={{ padding: '3% 3% 0 3%' }}>
                        <button type="button" className="secondary-button" onClick={downloadSampleCsv}>
                            <span className="secondary-button-icon"><DownloadIcon /></span>
                            <span className="secondary-button-text">Download Sample CSV</span>
                        </button>
                    </div>
                    <div style={{ padding: '3%' }}>
                        <label for="DeviceName" className="label">File Name & Location</label>
                        <div>
                            <input class="inputBox" placeholder={fileName} disabled />
                            <input type="File" id="uploadFile" style={{ display: "none" }} onChange={onChangeHandler} accept=".csv" />
                            <label for="uploadFile" className="secondary-button upload" style={{ float: "right" }}><span className="secondary-button-text">Select File</span></label>
                        </div>
                    </div>
                    <Modal.Footer className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={() => {
                                setFileName("");
                                setFileType("");
                                setError("");
                                setMessagePopup(false);
                                setJsonData([]);
                            }}>
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><UploadDeviceIcon /></span>
                                <span className="primary-button-text">Upload</span>
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal >
    );
}

export default UploadDevice;